import { useEffect } from 'react';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import fetch from 'features/common/fetch';
import campaignRegions from 'features/views/campaignDashboards/campaignRegions';
import campaigns from 'features/views/campaignDashboards/campaigns';
import dashboardSidebar from 'features/views/campaignDashboards/sidebar';
import dashboardStructure from 'features/views/campaignDashboards/structure';

import RegionsTable from './components/RegionsTable';

const { urls } = fetch.constants;

export const DashboardCentral = () => {
	const dispatch = useDispatch();

	const campaignId = useSelector(dashboardStructure.selectors.getCampaignId);
	const campaign = useSelector((state) => campaigns.selectors.getCampaignById(state, campaignId));

	useEffect(() => {
		if (!isEmpty(campaign)) {
			dispatch(dashboardSidebar.actions.fetchSummary(campaign, urls.dashboardCentralSummary, []));
			dispatch(campaignRegions.actions.getRegions(campaign.id, []));
		}
	}, [dispatch, campaign]);

	return <RegionsTable campaignType={campaign.type} />;
};

export default DashboardCentral;
